import {
	Directive, ElementRef,
	Input, OnChanges,
	OnInit, SimpleChanges
}                            from '@angular/core';
import { LoggerService }     from '@app/shared/services/logger.service';
import { APP_MODE_SETTINGS } from '@appConfig/app-mode-config';
import { APP_CONFIG }        from '@appConfig/_app-config_master';

@Directive( {
	selector: '[appLimitHandlerDirective]'
} )
export class LimitHandlerDirective implements OnChanges, OnInit {

	@Input() limitType: string = null;

	@Input() listLength: number = null;

	@Input() actionType: string = null;

	constructor(
		private el: ElementRef,
		private logger: LoggerService
	) {}


	private runHandler() {
		const mode = APP_CONFIG.appMode;
		const limitValue = APP_MODE_SETTINGS[ mode ].limits[ this.limitType ];
		const limit = limitValue ? limitValue : null;

		this.logger.debug( 'LimitHandlerDirective mode :', mode );
		this.logger.debug( 'LimitHandlerDirective limitType: ', this.limitType );
		this.logger.debug( 'LimitHandlerDirective listLength: ', this.listLength );
		this.logger.debug( 'LimitHandlerDirective actionType: ', this.actionType );


		if ( limit !== null && this.listLength >= limit ) {

			switch ( this.actionType ) {
				case 'hide':
					this.el.nativeElement.style.display = 'none';
					break;
				case 'disable':
					this.el.nativeElement.style.pointerEvents = 'none';
					this.el.nativeElement.style.opacity = .7;
					break;
			}
		} else {
			this.el.nativeElement.style.display = 'initial';
			this.el.nativeElement.style.opacity = 'initial';

			if ( !this.el.nativeElement.classList.contains( 'disabled' ) ) {
				this.el.nativeElement.style.pointerEvents = 'initial';
			}
		}
	}

	ngOnChanges( changes: SimpleChanges ) { this.runHandler(); }

	ngOnInit() { this.runHandler(); }
}
